import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../shared/services/local-storage.service';

export const amcGuard: CanActivateFn = (route, state) => {
 const router = inject(Router);
 const localStorageService = inject(LocalStorageService);

  const type = localStorageService.getDataByKey('contributorMemberType');

  if (type === 'collaborative') {
    return true; // allow navigation
  }
  return router.createUrlTree(['']);
   
};
